type MainStoreakeSelectOptions = {
  value: 'value' | string;
  label: 'label' | string;
};

export function makeSelectOption(
  data: string,
  { value, label }: MainStoreakeSelectOptions = { value: 'value', label: 'label' },
  labelData?: string
) {
  return { [value]: data, [label]: labelData || data };
}

export function makeSelectOptions(
  data: string[],
  { value, label }: MainStoreakeSelectOptions = { value: 'value', label: 'label' },
  labelData?: string[]
) {
  return data.map((item, index) => makeSelectOption(item, { value, label }, labelData?.[index]));
}
